// extracted by mini-css-extract-plugin
module.exports = {"footer":"style-module--footer--6v-NO","img":"style-module--img--3hayk","row":"style-module--row--2bcRj","cell":"style-module--cell--262iS"};